import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import classNames from 'classnames';
import Popup from '/@/components/popup';
import { _ } from '/@/locale';
import styles from './styles.module.css';

const Dialog = ({
    visible,
    title,
    message = '',
    children,
    alignCenter,
    acceptLabel,
    cancelLabel,
    onClose,
    onCancel,
    onAccept,
}: {
    visible: boolean;
    title: string;
    message: string;
    children: React.ReactNode;
    alignCenter: boolean;
    acceptLabel: string;
    cancelLabel: string;
    onClose: () => void;
    onCancel: () => void;
    onAccept: () => void;
}) => {
    return (
        <Popup onClose={onClose} visible={visible}>
            <div className={styles.root}>
                {title && <p className={styles.title}>{title}</p>}
                <div className={classNames(styles.message, alignCenter && styles.alignCenter)}>
                    {children}
                    {message && message.split(/[\r\n]+/).map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </div>
                <Stack direction='row' spacing={2}>
                    {onCancel && (
                        <Button variant='outlined' onClick={onCancel} fullWidth>
                            {cancelLabel || _('Cancelar')}
                        </Button>
                    )}
                    {onAccept && (
                        <Button variant='contained' onClick={onAccept} fullWidth>
                            {acceptLabel || _('Aceptar')}
                        </Button>
                    )}
                </Stack>
            </div>
        </Popup>
    );
};

export default Dialog;
